import { render } from "./FeaturedLinks.vue?vue&type=template&id=8f355be8&scoped=true&lang=pug"
import script from "./FeaturedLinks.vue?vue&type=script&lang=ts"
export * from "./FeaturedLinks.vue?vue&type=script&lang=ts"

import "./FeaturedLinks.vue?vue&type=style&index=0&id=8f355be8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8f355be8"

export default script